import './homePage.css'

const HomePage = () => {
  const welcomeText = 'Welcome to our website!'

  return (
    <>
      <h1>Home</h1>
      <h3>{welcomeText}</h3>
      <div className="home-wrapper">
        <div>
          Check out our <a href="/database">Database</a> page.
        </div>
      </div>
      <div>
        <h2>React</h2>
        <p>The library for web and native user interfaces</p>
      </div>
    </>
  )
}

export default HomePage
